<template lang="pug">
  v-card
    v-card-title.primary--text.justify-center.grey.lighten-4
      .title CONSOMMATION ESTIMÉE : {{ currentYear +1 }}
    v-card-text.pa-0
      v-layout
        v-flex.xs5.pa-3
          v-layout.align-center.column
            .title.font-weight-regular.text-xs-center
              div Consommation
              div estimée pour {{ currentYear + 1 }} :
            v-layout.align-center
              .display-1.font-weight-bold.my-3 {{ nextYearEstimation | spaceOut }}
              .subheading.pl-2 Affichages
        v-divider.grey(vertical)
        v-flex.xs7.pa-3
          v-layout.align-center.column
            .title.font-weight-regular.text-xs-center.pb-2 Nouveau forfait :
            v-layout.align-center(v-if="offer.consumption_limit")
              .display-1.font-weight-bold {{ offer.consumption_limit | spaceOut }}
              .subheading.pl-2 Affichages
            v-layout.align-center(v-else)
              .display-1.font-weight-bold 0
              .subheading.pl-2 Affichages
            span.pt-4
              span.display-1.font-weight-bold(v-if="offer.price") {{ offer.price }}€ HT
              span.display-1.font-weight-bold(v-else) 0€ HT
              span.headline.grey--text /mois
                sup.primary--text(v-if="offer.discount") {{ offer.discount }}
</template>

<script>
export default {
  computed: {
    currentYear() {
      return this.$store.state.consumption.currentYear;
    },
    offer() {
      return this.$store.state.consumption.consumption.next_year_offer || {};
    },
    nextYearEstimation() {
      return this.$store.state.consumption.consumption.next_year_estimation || 0;
    },
  },
};
</script>

<style lang="scss">
  .light-bg {
    background-color: #fff3e6;
  }
</style>
